import {Component, Input} from '@angular/core';
import {InfoUI, TypeInfoEnum} from '../../entity';

@Component({
    selector   : 'mo-lemken-info',
    templateUrl: './mo-lemken-info.component.html',
    styleUrls  : ['./mo-lemken-info.component.scss']
})
export class MoLemkenInfoComponent {
    /**
     * Infos tabs
     */
    private _infoTabs: Array<Array<InfoUI>> = [];
    /**
     * Index.
     */
    private _index: number = 0;
    /**
     * Have Data.
     */
    private _haveData: boolean = false;
    /**
     * Items Number
     */
    private _itemsNumber: number = -1;

    /**
     * Defautl Constructor.
     */
    constructor() {
    }


    /**
     * Gette.
     */
    @Input()
    public get infoTabs(): Array<Array<InfoUI>> {
        return this._infoTabs;
    }

    /**
     * Setter.
     * @param value
     */
    public set infoTabs(value: Array<Array<InfoUI>>) {
        this._infoTabs = value;
        this._itemsNumber = this._infoTabs.length;
        this._haveData = this._itemsNumber > 0;
        this._index = 0;
    }

    /**
     * Getter Current Index
     */
    public get index(): number {
        return this._index;
    }

    /**
     * Get HaveData indicator
     */
    public get haveData(): boolean {
        return this._haveData;
    }

    /**
     * Get then nimber of items
     */
    public get itemsNumber(): number {
        return this._itemsNumber;
    }

    /**
     * Next Page
     */
    public nextPage(): void {
        if (this._index + 1 < this._itemsNumber) {
            this._index++;
        }
    }

    /**
     * Previous Page
     */
    public previousPage(): void {
        if (this._index > 0) {
            this._index--;
        }
    }

    /**
     * Get class for display
     * @param info
     */
    public getClassUI(info: InfoUI): string {
        let res: string = 'text-lemken';
        if (info.type === TypeInfoEnum.DANGER) {
            res = 'text-danger';
        }
        return res;
    }
}
